<template>
    <div>
        <div class="pageTop">
            <div class='left'>
                <p  class='title'>{{farmNodeInfo.name}}</p>                
            </div>
            <div class='right'>                
                <van-icon name="apps-o" color='#0076bf' size='22' @click="rListShow" style="vertical-align: middle;margin-left:15px"/>                
            </div>
        </div>                
        <div id='allmap' class="map flex-1" ref="map" style="width:100%"></div>
        
    </div>
</template>

<script>
import inMap from 'inmap'
import gcoord from 'gcoord'
import {getBaseList,getNodePointHome,getNodeValvePoint,getNodeCamera } from '@/request/data'
import onlineIcon from '@/assets/online.png'
import offlineIcon from '@/assets/offline.png'
import fm from '@/assets/fm.png'
import pump from '@/assets/pump.png'
import cameraIcon from '@/assets/camera.png'
import { mapState,mapMutations } from 'vuex'
var inmap,overlay,valveMkr,pumpMkr,cameraMkr
export default {
    props:{
        uuid:{
            type:[String,Number],
            required: true
        },
        baseName:{
            type:String,
        }
    },
    data() {
        return {
            clientHeight:''
        }
    },
    computed: {
        ...mapState(['farmNodeNameState','farmNodeInfo'])
    },
    watch: {
        clientHeight: function () {
            this.changeFixed(this.clientHeight)
        },    
    },
    mounted() {
        this.clientHeight =   `${document.documentElement.clientHeight}`
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
        };
        this.setMap()
        
        console.log(this.farmNodeInfo)
    },
    methods: {        
        setMap(){//加载底层地图 
            inmap = new inMap.Map({
                id: "allmap",
                skin: "",
                center: [105.629784,37.042082],
                zoom: {
                value: 5,
                show: true,
                max: 18
                }
            })            
            this.getNodePointHome(this.farmNodeInfo.uuid,this.farmNodeInfo.coordinate)
        },
        getNodePointHome(uuid,coordinate){//获得地块坐标
            let data = {}
            data.uuid = uuid
            // data.token = this.token
            // console.log(this.info)
        getNodePointHome(data).then(res=>{
            if (coordinate) {
                  console.log(coordinate)
                inmap.remove(overlay)
                let baseImg
		        if (this.farmNodeInfo.isLogin =='0') {
		        	baseImg= new BMap.Icon(offlineIcon, new BMap.Size(30, 43), {
		        		nchor: new BMap.Size(30, 43)
		        	});
		        }else{
		        	baseImg= new BMap.Icon(onlineIcon, new BMap.Size(30, 43), {
		        		nchor: new BMap.Size(30, 43)
		        	});
		        }		
                let point = this.farmNodeInfo.coordinate.split(',')
                let baseMkr = new BMap.Marker(new BMap.Point(point[0],point[1]), { icon: baseImg });                
		            inmap.getMap().addOverlay(baseMkr);
                inmap.getMap().centerAndZoom(new BMap.Point(point[0],point[1]), 16)
            }else{
              this.$toast.fail({message:'该基地暂无坐标',forbidClick:true,duration:1000});  
                                           
            }            
            if (res.data.data.land.length != 0) {
              this.basedata = res.data.data.land              
            //   this.cameraInfoList = res.data.data.camera
              this.setInMap(res.data.data.land)              
              this.forValve(uuid)//加载阀门
              this.NodeCamera(uuid)//加载摄像头图标
          } else {
              this.basedata = []
              this.$toast.fail({message:'该基地暂无地块',forbidClick:true,duration:1000});              
            //   this.cameraInfoList = []
            //   this.forValve(uuid)
              
          }
            })
        },
        setInMap(landData){//创建地块
            overlay = new inMap.PolygonOverlay({
                tooltip: {
                    show: false,          
                },
                event: {
                    onMouseClick: function (item, event) { //点击事件
                    }
                },
                legend: {
                    show: false,
                    title: ""
                },
                style: {
                    normal: {
                      borderWidth: 1.5,
                      label: {
                        show: true, // 是否显示
                        font: "13px bold ",
                        color: "#fff"
                      }
                    },
                    mouseOver: { //鼠标经过样式
                        shadowColor: "rgba(0,133,235,0.2)",
                        shadowBlur: 0,
                        borderWidth: 0,
                        label: {
                          color: "rgba(0, 0, 0, 1)"
                        }
                    },
                    selected: { //鼠标选中状态的样式
                        backgroundColor: "rgba(0,133,235,0.40)", //背景颜色
                        borderColor: "rgba(0,133,235,1)",
                        label: {
                            color: "rgba(255,255,255,1)" //字颜色
                        }
                    },
                    colors: ["rgba(0,133,235,0.40)"]
                }
            });
             inmap.add(overlay);
            //坐标转换,用gcoord.js
            for (let index = 0; index < landData.length; index++) {
                let geojson = landData[index].geometry
                gcoord.transform(geojson, gcoord.WGS84, gcoord.BD09);
                landData[index].geometry = geojson
            }  
            overlay.setData(landData);
      },
        forValve(uuid){//循环阀门
            let data ={}
            data.uuid = uuid
            // data.token = this.token
            getNodeValvePoint(data).then(res=>{            
                if(res.data.data){
                this.valvedata = res.data.data
                }
                for (let i = 0; i < this.valvedata.length; i++) {
                    //阀门坐标
                    if (this.valvedata[i].coordinate !== null) {
                    let point = this.valvedata[i].coordinate.split(',')
                    let bindLand = this.valvedata[i].land
                    let type = this.valvedata[i].type
                    // let point =gcoord.transform([parseInt(p[0]),parseInt(p[1])], gcoord.WGS84,gcoord.BD09 )
                    this.addValve(point,bindLand,type)
                    }
                }
                

            }).catch()

        },
        addValve(point,bindLand,type){//创建阀门图标
            let _that = this
            switch (type) {
                case 0:
                let fmImg = new BMap.Icon(fm, new BMap.Size(30, 23), {
                    nchor: new BMap.Size(30, 23)
                });
                valveMkr = new BMap.Marker(new BMap.Point(point[0],point[1]), { icon: fmImg });
                inmap.getMap().addOverlay(valveMkr);
                // this.deviceShowHide.valve.push(valveMkr)
                valveMkr.addEventListener("click", function () {
                    _that.io=false;        
                    let p = this.getPosition(); //获取marker的位置
                    // console.log("阀门的位置是" + p.lng + "," + p.lat);
                    setTimeout(() => {_that.io=true}, 100);
                });              
                break;
                case 1:
                let pumpImg = new BMap.Icon(pump, new BMap.Size(40, 40), {
                    nchor: new BMap.Size(40, 40)
                });
                //pumpMkr
                pumpMkr = new BMap.Marker(new BMap.Point(point[0],point[1]), { icon: pumpImg });
                inmap.getMap().addOverlay(pumpMkr);
                // this.deviceShowHide.pump.push(pumpMkr)
                break;
                default:
                break;
            }
            // valveMkr.disableDragging();
            // pumpMkr.disableDragging();
            //点击事件
        },
        NodeCamera(uuid){//基地摄像头坐标
        let data = {}
        data.uuid = uuid
        // data.token = this.token
        getNodeCamera(uuid).then(res=>{
            if (res.data.code ==0 ) {        
            if (res.data.hasOwnProperty('data')) {
                for (let i = 0; i < res.data.data.length; i++) {
                if (res.data.data[i].coordinate != ",") {
                    this.addCamera(res.data.data[i])
                }
                }
            }
            }else{
            // AlertModule.show({
            //   title: '该基地暂无摄像头',
            // })
            }
        }).catch()
        },
        addCamera(info){//创建摄像头图标
            let point =info.coordinate.split(',')
            let _that = this
            let cameraImg = new BMap.Icon(cameraIcon, new BMap.Size(48, 48), {
                nchor: new BMap.Size(48, 48)
            });
            cameraMkr = new BMap.Marker(new BMap.Point(point[0],point[1]), { icon: cameraImg });
            inmap.getMap().addOverlay(cameraMkr);    
            // this.deviceShowHide.camera.push(cameraMkr)
            cameraMkr.disableDragging(); 
        },
        rListShow(){
            this.$emit('rListSon', 1);
        },
        changeFixed(clientHeight){//动态修改地图高度样式            
                this.$refs.map.style.height = (clientHeight-134)+'px';        
                    
        },
        
    },

}
</script>

<style scoped>

</style>